<template>
  <div class="mc-report-view__table">
    <div class="row">
      <!-- Search -->
      <div class="col-md-12">
        <div class="mc-table-view">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
            <label class="
                  d-inline-flex
                  align-items-center
                  mc-table-view__search
                ">
              <i class="mc-fa fas fa-search"></i>
              <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'" :disabled="true"
                class="ms-2"></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table :rows="3" :columns="fields.length" :table-props="{ bordered: true, striped: true }">
            </b-skeleton-table>
          </b-card>
        </template>
        <b-table class="datatables" :items="listData" :fields="fields" responsive="md" show-empty
          :empty-text="$t('global.emptyTable')" 
          :per-page="perPage"
          :empty-filtered-text="$t('global.emptyFilteredTable')" 
          :filter="filter"
          :filter-included-fields="filterOn" @filtered="onFiltered">
          <template #cell(sentOn)="data">
            {{ data.item.reportDetailVehicleTrip ? momentDateShortMonth(data.item.reportDetailVehicleTrip.sentOn) : '-'
            }}<br />
            <span class="text-muted">{{ data.item.reportDetailVehicleTrip ?
            momentTimeSeconds(data.item.reportDetailVehicleTrip.sentOn) : '-' }}</span>
          </template>

          <template #cell(driver)="data">
            {{ data.item.driver&&data.item.driver.fullname ? data.item.driver.fullname : '-' }}
          </template>

          <template #cell(address)="data">
            <a
                class="link-primary"
                :href="`https://www.google.com/maps/search/?api=1&query=${data.item.reportDetailVehicleTrip.latitude},${data.item.reportDetailVehicleTrip.longitude}`"
                target="_blank"
                v-if="data.item.reportDetailVehicleTrip && data.item.reportDetailVehicleTrip.latitude && data.item.reportDetailVehicleTrip.longitude && data.item.reportDetailVehicleTrip.address"
                >{{data.item.reportDetailVehicleTrip.address}}</a>
            <span v-else>-</span>
          </template>

          <template #cell(vehicle)="data">
            {{ data.item.reportDetailVehicleTrip.vehicle ? data.item.reportDetailVehicleTrip.vehicle.licensePlate : '-'
            }}
          </template>

          <template #cell(vehicleType)="data">
            {{ data.item.reportDetailVehicleTrip.vehicle ? (data.item.reportDetailVehicleTrip.vehicle.vehicleType ?
            data.item.reportDetailVehicleTrip.vehicle.vehicleType.manufacturer : '-') : '-'
            }} / {{
            data.item.reportDetailVehicleTrip.vehicle ? (data.item.reportDetailVehicleTrip.vehicle.vehicleType ?
            data.item.reportDetailVehicleTrip.vehicle.vehicleType.model : '-') : '-'
            }} / {{
            data.item.reportDetailVehicleTrip.vehicle ? (data.item.reportDetailVehicleTrip.vehicle.vehicleType ?
            data.item.reportDetailVehicleTrip.vehicle.vehicleType.type : '-') : '-'
            }}
          </template>

          <template #cell(latitude)="data">
            {{ data.item.reportDetailVehicleTrip.latitude }}
          </template>

          <template #cell(longitude)="data">
            {{ data.item.reportDetailVehicleTrip.longitude }}
          </template>

          <template #cell(speed)="data">
            {{ minimizeFloat(data.item.reportDetailVehicleTrip.speed) }}
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </div>
    <div class="row mt-3" v-if="fields.length > 0">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Menampilkan
            <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions">
            </b-form-select>
            entri. 
            <p>
              Menampilkan
              <strong>{{ (currentPage - 1) * perPage + 1 }}</strong>
              - <strong>{{ Math.min( (currentPage - 1) * perPage + reportDetailVehicleTrip.reportDetailVehicleTrips.length, currentPage * perPage, totalRows) }}</strong> dari
              <strong>{{ totalRows }}</strong>
            </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination @change="changePage" v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows" :per-page="perPage">
            </b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { GET_REPORT_DETAIL_HISTORY_FLEET } from "@/services/api/report/report"
import moment from "moment";
import { Helper } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { EXPORT_EXCEL_REPORT_DETAIL_HISTORY_VEHICLE } from "@/services/api/report/excel";
import { EXPORT_PDF_REPORT_DETAIL_HISTORY_VEHICLE } from "@/services/api/report/pdf";

moment.locale("id");

export default {
  name: "DetailFleetHistoryTable",
  mixins: [Helper, Export],
  data() {
    return {
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      reportDetailVehicleTrip: {
        reportDetailVehicleTrips: []
      },
      fields: [],
      isLoading: false,
      fileName: '',
      openSection: false,
      periode: [],
      filtersField: [],
      isEmpty: true,
      interval: {
        key: 1,
        label: '1 Menit'
      },
      filteredItems: [],
      vehicleId: null
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.reportDetailVehicleTrip.reportDetailVehicleTrips.length;
    },
    listData() {
      return this.reportDetailVehicleTrip.reportDetailVehicleTrips;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.reportDetailVehicleTrip.reportDetailVehicleTrips.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    refreshData() {
      this.isLoading = true;
      this.isEmpty = true;
      const periode = this.periode;
      const interval = this.interval;
      const filter = this.vehicleId
      let filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: [filter]
        }
      }

      let filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        interval: interval.key,
        ...filters,
        pagination:{
          page:this.currentPage,
          show:this.perPage
        }
      };

      var self = this;
      var getData = this.$apollo
        .query({
          query: GET_REPORT_DETAIL_HISTORY_FLEET,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache'
        }).then(res => {
          const data = res.data;
          self.totalRows = data.reportDetailVehicleTrip.reportDetailVehicleTrips.pagination.total;
          if (data.reportDetailVehicleTrip.reportDetailVehicleTrips.data.length === 0) {
            self.isEmpty = true;
            self.reportDetailVehicleTrip.reportDetailVehicleTrips = [];
            self.isLoading = false;
            return [];
          }
          self.isEmpty = false;

          self.reportDetailVehicleTrip.reportDetailVehicleTrips = data.reportDetailVehicleTrip.reportDetailVehicleTrips.data;
          self.filteredItems = data.reportDetailVehicleTrip.reportDetailVehicleTrips;

          self.isLoading = false;
        })

      return getData;
    },

    openTable(periode, filter, interval, fields) {
      this.periode = periode;
      this.interval = interval;
      this.filtersField = filter;
      this.fields = fields;
      this.vehicleId = filter;
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData();
          this.openSection = false;
        }, 800);
      })

    },

    downloadToExcel(periode, filter, interval, fields) {
      var filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: [filter]
        }
      }


      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        interval: interval.key,
        column: fields.map(item => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}, Interval : ${interval.label}`,
        ...filters
      };

      var downloadProgress = {
        name : 'Detail Riwayat Kendaraan ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY")+'.xlsx',
        periode : moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt : moment().format('DD MMM YYYY HH:mm:ss'),
        percentage : 0,
        type : 'excel'
      };
      this.$store.commit("report/saveProgress", downloadProgress);
      
      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if(percentage< 75) {
          percentage += 25;
        }else if(percentage== 75) {
          percentage = 90;
        }else if(percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: percentage});
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_EXCEL_REPORT_DETAIL_HISTORY_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache'
        }).then(res => {
          var isSuccessful = res.data.excelReportDetailVehicleTrip.isSuccessful;
          if(isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 100});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 90});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        })
    },

    downloadToPdf(periode, filter, interval, fields) {
      var filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: [filter]
        }
      }

      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        interval: interval.key,
        column: fields.map(item => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}, Interval : ${interval.label}`,
        ...filters
      };

      var downloadProgress = {
        name : 'Detail Riwayat Kendaraan ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY")+'.pdf',
        periode : moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt : moment().format('DD MMM YYYY HH:mm:ss'),
        percentage : 0,
        type : 'pdf'
      };
      this.$store.commit("report/saveProgress", downloadProgress);
      
      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if(percentage< 75) {
          percentage += 25;
        }else if(percentage== 75) {
          percentage = 90;
        }else if(percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: percentage});
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_REPORT_DETAIL_HISTORY_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache'
        }).then(res => {
          var isSuccessful = res.data.pdfReportDetailVehicleTrip.isSuccessful;
          if(isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 100});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 90});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        })
    },
    changePage(page) {
      this.currentPage = page
      this.refreshData()
    },
  },
  watch:{
    perPage(val) {
      this.perPage = val;
      this.currentPage = 1;
      this.refreshData()
    },
    filter(val) {
      this.filter = val;
      this.currentPage = 1;
      this.refreshData()
    },
  }
};
</script>